import React from 'react';
import { Code, Database, GraduationCap, BookOpen, Award } from 'lucide-react';
import { formacionData } from '../mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

const iconMap = {
  Code: Code,
  Database: Database,
  GraduationCap: GraduationCap,
  BookOpen: BookOpen
};

const FormacionSection = () => {
  return (
    <section id="formacion" className="py-24 bg-black relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-3 mb-4">
              <Award className="text-green-400" size={32} />
              <h2 className="text-4xl md:text-5xl font-bold text-green-400 font-mono">
                {'<'} {formacionData.title} {'/>'} 
              </h2>
              <Award className="text-green-400" size={32} />
            </div>
            <p className="text-gray-400 text-lg font-mono">{formacionData.subtitle}</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {formacionData.degrees.map((degree, index) => {
              const Icon = iconMap[degree.icon];
              return (
                <Card
                  key={degree.id}
                  className="bg-gray-900/50 border-green-500/30 hover:border-green-400 transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-green-500/20 backdrop-blur-sm group"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="w-16 h-16 bg-green-500/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-green-500/20 transition-colors">
                        <Icon className="text-green-400" size={32} />
                      </div>
                      <div className="flex-1">
                        <CardTitle className="text-xl md:text-2xl text-green-400 font-mono mb-2">
                          {degree.title}
                        </CardTitle>
                        <p className="text-gray-400 font-mono text-sm">{degree.institution}</p>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="flex items-center justify-between">
                      <span className="text-green-500 font-mono font-bold text-sm">
                        {degree.year}
                      </span>
                      <div className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>

          <div className="mt-16 text-center">
            <div className="inline-block bg-gray-900/50 border border-green-500/30 rounded-lg p-8">
              <p className="text-gray-300 font-mono text-lg">
                💡 <span className="text-green-400">Educación continua</span> y aprendizaje constante
              </p>
              <p className="text-gray-500 font-mono text-sm mt-2">
                Siempre explorando nuevas tecnologías y metodologías
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FormacionSection;
